import { Context, Layer, type Effect, type Scope } from "effect";
import type { PanePointerFailure, PanePointerMove } from "./pane-pointer-model.ts";

export class PanePointerIo extends Context.Service<PanePointerIo, {
  readonly capture: (target: HTMLElement, pointerId: number, prevent: () => void) => Effect.Effect<void, PanePointerFailure>;
  readonly measure: (container: HTMLElement, input: PanePointerMove) => Effect.Effect<number | null, PanePointerFailure>;
  readonly release: (target: HTMLElement, pointerId: number) => Effect.Effect<void, PanePointerFailure>;
}>()("workerstation/frontend/PanePointerIo") {}
export const PanePointerIoTest = (io: typeof PanePointerIo.Service) => Layer.succeed(PanePointerIo, io);
export type PanePointerCommand =
  | { readonly _tag: "Start"; readonly target: HTMLElement; readonly input: unknown; readonly prevent: () => void }
  | { readonly _tag: "Move"; readonly target: HTMLElement; readonly container: HTMLElement | null; readonly input: unknown; readonly notify: (ratio: number) => void }
  | { readonly _tag: "End" | "Lost"; readonly target: HTMLElement; readonly pointerId: number }
  | { readonly _tag: "Stop" };
export interface PanePointerSession { readonly receive: (command: PanePointerCommand) => Effect.Effect<void> }
export class PanePointers extends Context.Service<PanePointers, {
  readonly open: (dragging: (value: boolean) => void) => Effect.Effect<PanePointerSession, never, Scope.Scope>;
}>()("workerstation/frontend/PanePointers") {}
export const PanePointersTest = (service: typeof PanePointers.Service) => Layer.succeed(PanePointers, service);
